<div class="labeled-container">
  <div class="label">{{ label }}</div>
  <div class="content rounded">
    <ng-content></ng-content>
  </div>
</div>
